import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import dayjs from "dayjs";
import { ScrollText } from "lucide-react";

const ACTION_COLORS = {
  create: "text-emerald-400",
  update: "text-amber-400",
  delete: "text-destructive",
};

export default function Audit() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/audit", { params: { limit: 300 } }).then(({ data }) => setLogs(data));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Registro Modifiche (Audit)</h1>
        <p className="text-sm text-muted-foreground">Tracciamento di tutte le operazioni sui dati economici.</p>
      </div>

      <div className="divide-y divide-border/50 rounded-xl border border-border bg-card">
        {logs.length ? logs.map((l) => (
          <div key={l.id} className="flex items-start gap-3 px-5 py-3" data-testid={`audit-row-${l.id}`}>
            <ScrollText className={`mt-0.5 h-4 w-4 shrink-0 ${ACTION_COLORS[l.action] || "text-muted-foreground"}`} />
            <div className="flex-1">
              <div className="text-sm">{l.description}</div>
              <div className="text-xs text-muted-foreground">
                {dayjs(l.timestamp).format("DD/MM/YYYY HH:mm")} · <b>{l.username}</b> · {l.action}
                {l.store_name && <span> · <span className="text-primary">{l.store_name}</span></span>}
                {l.field && l.old_value !== "" && <span> · da <b>{l.old_value}</b> a <b>{l.new_value}</b></span>}
              </div>
            </div>
          </div>
        )) : <div className="px-5 py-10 text-center text-muted-foreground">Nessuna modifica registrata.</div>}
      </div>
    </div>
  );
}
